import { render, staticRenderFns } from "./sentence.vue?vue&type=template&id=5549a211&scoped=true&"
import script from "./sentence.vue?vue&type=script&lang=js&"
export * from "./sentence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5549a211",
  null
  
)

export default component.exports